import React from 'react'
import styles from './MediaPanelLayout.module.scss'

interface MediaPanelLayoutProps {
  children: React.ReactNode
  className?: never
}

export const MediaPanelLayout: React.FC<MediaPanelLayoutProps> = ({ children }) => (
  <div className={styles.layout}>{children}</div>
)
